import React, { useEffect, useState } from 'react';
import { Search, RefreshCw } from 'lucide-react';
import api from '../../utils/api';

const fmtDate = (s) => s ? new Date(s).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [acao, setAcao] = useState('');
  const [ator, setAtor] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/admin/logs', { params: { acao: acao || undefined, ator: ator || undefined, limit: 200 } })
      .then(r => setLogs(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [acao, ator]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-stone-900">Audit Logs</h1>
        <button onClick={load} className="p-2 rounded-lg border border-stone-200 hover:bg-stone-50 text-stone-500">
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      <div className="flex gap-3 mb-4">
        <div className="relative flex-1">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
          <input value={acao} onChange={e => setAcao(e.target.value)} placeholder="Filtrar por ação..."
            className="w-full pl-9 pr-4 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:border-[#0f3d2e]" />
        </div>
        <div className="relative flex-1">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
          <input value={ator} onChange={e => setAtor(e.target.value)} placeholder="Filtrar por ator (email)..."
            className="w-full pl-9 pr-4 py-2.5 border border-stone-200 rounded-lg text-sm focus:outline-none focus:border-[#0f3d2e]" />
        </div>
      </div>

      <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-xs">
            <tr><th className="text-left px-4 py-3">Data / Hora</th><th className="text-left px-4 py-3">Ação</th><th className="text-left px-4 py-3">Ator</th><th className="text-left px-4 py-3">Detalhes</th><th className="text-left px-4 py-3">IP</th></tr>
          </thead>
          <tbody className="divide-y divide-stone-50">
            {loading ? <tr><td colSpan={5} className="px-4 py-8 text-center text-stone-400">Carregando...</td></tr>
              : logs.length === 0 ? <tr><td colSpan={5} className="px-4 py-8 text-center text-stone-400">Nenhum log encontrado</td></tr>
              : logs.map(l => (
                <tr key={l.id} className="hover:bg-stone-50">
                  <td className="px-4 py-3 text-stone-400 text-xs whitespace-nowrap">{fmtDate(l.timestamp)}</td>
                  <td className="px-4 py-3"><span className="font-mono text-xs bg-stone-100 text-stone-700 px-2 py-0.5 rounded">{l.acao}</span></td>
                  <td className="px-4 py-3 text-stone-500 text-xs">{l.ator_email || 'sistema'}</td>
                  <td className="px-4 py-3 text-stone-400 text-xs max-w-[200px] truncate">{JSON.stringify(l.detalhes)}</td>
                  <td className="px-4 py-3 text-stone-400 text-xs">{l.ip || '—'}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
